import { render, staticRenderFns } from "./configure-preference-page.vue?vue&type=template&id=0d1906d2"
import script from "./configure-preference-page.vue?vue&type=script&lang=js"
export * from "./configure-preference-page.vue?vue&type=script&lang=js"
import style0 from "./configure-preference-page.vue?vue&type=style&index=0&id=0d1906d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports